import { h } from 'preact';
import PropTypes from 'prop-types';

const Wrapper = ({ tag = 'div', className, children, isWrapping, ...tagAttributes }) => {
  if (!isWrapping) {
    return children;
  }
  const Tag = tag;
  return (
    <Tag className={className} {...tagAttributes}>
      {children}
    </Tag>
  );
};

Wrapper.propTypes = {
  tag: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
  isWrapping: PropTypes.bool.isRequired,
};

export default Wrapper;
